import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {getNextQuizList} from "examsbook-react-sdk/actions";
import useSelectedExam from "./useSelectedExam";

/**
 * get list of next quizzes
 * @returns {{nextQuizList: *}}
 */
export default function useNextQuizList(){
    const dispatch = useDispatch();
    const nextQuizList = useSelector((state)=>state.nextQuizList);
    const selectedExam =  useSelectedExam();
    useEffect(()=>{
        if(selectedExam) {
            getNextQuizListData();
        }
    }, [selectedExam]);

    function getNextQuizListData(){
        dispatch(getNextQuizList(selectedExam._id));
    }

    return {
        nextQuizList
    };
}